import BackendService from "./BackendService";

async function getTerminals(params) {
  return BackendService.getData("/terminals/", {}, params);
}

async function getTerminal(id) {
  return BackendService.getData(`/terminals/${id}/`);
}

async function attachTerminal(id, data = {}) {
  return BackendService.patch(`/terminals/${id}/attach/`, data);
}

async function detachTerminal(id) {
  return BackendService.patch(`/terminals/${id}/detach/`);
}

async function updateTerminalConfig(id, data = {}) {
  return BackendService.patch(`/terminals/${id}/`, data);
}

async function updateTerminalNotificationToken(id, token) {
  return BackendService.patch(`/terminals/${id}/`, { notification_token: token });
}

const TerminalService = {
  getTerminals,
  getTerminal,
  attachTerminal,
  detachTerminal,
  updateTerminalConfig,
  updateTerminalNotificationToken,
};

export default TerminalService;
